import { IonIcon } from '@ionic/react';
import React from 'react';

import useInView from '@/hooks/useInView';
import { TestimonialItem } from '@/utils/types';
import { star } from 'ionicons/icons';

import './TestimonialCard.css';

interface TestimonialCardProps {
  testimonial: TestimonialItem;
  index: number;
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({ testimonial }) => {
  const [ref, inView] = useInView({
    triggerOnce: true
  });

  const renderStars = () => {
    return Array.from({ length: 5 }, (_, starIndex) => (
      <IonIcon key={starIndex} icon={star} className="star" />
    ));
  };

  return (
    <div className={`testimonialCard ${inView ? 'inView' : ''}`}>
      <div className="testimonialImageContainer" ref={ref}>
        <img
          src={testimonial.image}
          alt={`${testimonial.clinic} testimonial`}
          className="testimonialImage"
        />
        <div className="starsContainer">{renderStars()}</div>
      </div>
      <div className="testimonialContent">{testimonial.content}</div>
      <div className="testimonialAuthor">
        <div className="authorName">{testimonial.author}</div>
        <div className="authorClinic">{testimonial.clinic}</div>
      </div>
    </div>
  );
};

export default TestimonialCard;
